import React from "react";
import IconFaMapPin from "../img/IconFaMapPin";
import IconFaChevRight from "../img/IconFaChevRight";

function ResumeCard(props) {
  window.scrollTo(0, 0); // scroll to top of page

  return (
    <div className="cv-card">
      <h4 className="cv-subtitle">
        <span className="dates">{props.year}</span>
        <span className="company">
          <a
            className="link-inline"
            href={props.site}
            target="_blank"
            rel="noopener noreferrer"
          >
            {props.company}
          </a>
        </span>
        <span className="location">
          <IconFaMapPin />
          {props.location}
        </span>
      </h4>
      <h5 className="cv-sectiontitle">
        <small>Title:</small>
        {props.title}
      </h5>
      <h5 className="cv-sectiontitle">
        <small>Summary:</small>
      </h5>
      <ul className="cv-list">
        {props.summary.map((list) => (
          <li className="item">
            <IconFaChevRight />
            {list}
          </li>
        ))}
      </ul>
      <h5 className="cv-sectiontitle">
        <small>Description:</small>
      </h5>
      <div className="cv-description">
        {props.description.map((paras) => (
          <p>{paras}</p>
        ))}
      </div>
    </div>
  );
}

export default ResumeCard;
